"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');

var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);
var _composer = require('shared/services/composer');

var _mentions = require('shared/services/mentions');
var _scheduledCancels = require('shared/services/scheduledCancels'); var _scheduledCancels2 = _interopRequireDefault(_scheduledCancels);
var _scheduledMessages = require('shared/services/scheduledMessages');
var _string = require('shared/services/string');




/* A composer's draft: its text and the mentions picked in it. */






















































const systemNow = () => new Date()
// After a reconnect (the server's ack, so the command goes out authed) the
// list is reloaded: pushes sent while the socket was down are gone.
const RECONNECT_ACTIONS = ['SERVER_ACK_SOCKET_CONNECTED']
const EMPTY_DRAFT = Object.freeze({ text: '', mentions: Object.freeze([]) })

// The reply a scheduled message carries, for the reply bar. The row names
// only the message; the bar finds its quote in the thread.
const replyOf = (message) => message.ReplyToMessageKey
  ? { messageKey: message.ReplyToMessageKey, preview: { MessageKey: message.ReplyToMessageKey } }
  : null

// Text and mentions as the server will store them, cleaned the way a normal
// send cleans them.
const normalized = (text, mentions) =>
  _mentions.normalizeMessageWithMentions.call(void 0, text, [...mentions])

// Why a scheduled text can't go as it is, or null.
const tooLongFor = (channel, text) =>
  channel === 'sms' && text.length > _composer.SMS_PART_LENGTH ? _composer.SCHEDULED_TEXT_TOO_LONG : null

const sameMentions = (a, b) =>
  a.length === b.length && a.every((mention, i) => {
    const other = b[i]
    return mention.Kind === other.Kind && (_nullishCoalesce(mention.TargetKey, () => ( ''))) === (_nullishCoalesce(other.TargetKey, () => ( ''))) &&
      mention.Start === other.Start && mention.End === other.End
  })

// What a schedule sends besides the text: the mentions and the reply, each
// only when there is one, as a normal send does.
const extrasFor = (mentions, reply) => ({
  ...(mentions.length ? { Mentions: mentions } : {}),
  ...(reply ? { ReplyToMessageKey: reply.messageKey } : {}),
})

/* Send later and the Scheduled bubble's actions, the same on every platform:
 * loads the chat's scheduled messages when it opens, schedules the typed text,
 * edits with the version it read, and turns the server's refusals into copy.
 * The platform draws the panel, the editing bar and the confirmation from
 * this state and calls back into it.
 *
 * A command's response always reaches the store (the reducer applies the
 * row). What it does to the screen (clearing or restoring the draft, ending
 * an edit, a notice) applies only while the screen is still where the command
 * left it: the same chat, the same editing session, and the draft it sent.
 *
 * Cancel never touches the draft: the bubble hides with an Undo toast, and
 * the cancel goes once Undo runs out or staff leave the chat
 * (scheduledCancels). */
 const useScheduledMessageFlow = ({ conversationKey, composer, notify, channel, now = systemNow }) => {
  const [sendLater, setSendLater] = _react.useState(null)
  const [sendLaterError, setSendLaterError] = _react.useState(null)
  const [editing, setEditing] = _react.useState(null)
  const [confirmingCancel, setConfirmingCancel] = _react.useState(null)
  const [busy, setBusy] = _react.useState.call(void 0, false)
  // The draft and the reply bar's reply from before Edit replaced them.
  const stashedDraft = _react.useRef(EMPTY_DRAFT)
  const stashedReply = _react.useRef(null)
  // Bumped whenever the chat changes, and whenever an editing session starts
  // or ends: a late response checks it still matches the one it began in.
  const chatGeneration = _react.useRef.call(void 0, 0)
  const editGeneration = _react.useRef.call(void 0, 0)
  // The command in flight, if any. Set synchronously, so a second tap before
  // the first returns sends nothing; only its own operation clears it.
  const inFlight = _react.useRef(null)
  const nextOperation = _react.useRef.call(void 0, 0)

  const latest = _react.useRef.call(void 0, { conversationKey, composer, notify, channel, now, sendLater, editing, confirmingCancel })
  _react.useLayoutEffect.call(void 0, () => {
    latest.current = { conversationKey, composer, notify, channel, now, sendLater, editing, confirmingCancel }
  })

  _react.useEffect.call(void 0, () => {
    chatGeneration.current += 1
    editGeneration.current += 1
    // A command still running in the last chat no longer blocks this one.
    inFlight.current = null
    stashedDraft.current = EMPTY_DRAFT
    stashedReply.current = null
    setBusy(false)
    setSendLater(null)
    setSendLaterError(null)
    setEditing(null)
    setConfirmingCancel(null)
    if (!conversationKey) return
    // Without the backend the thread just shows no bubbles.
    _actions2.default.listScheduledMessages(conversationKey).catch(() => null)
    // Leaving the chat sends its cancels still waiting for Undo.
    return () => _scheduledCancels2.default.commitChat(conversationKey)
  }, [conversationKey])

  const cancelToast = _react.useSyncExternalStore.call(void 0, 
    _scheduledCancels2.default.subscribe,
    () => _scheduledCancels2.default.toastFor(conversationKey),
  )

  const reload = _react.useCallback.call(void 0, () => {
    const key = latest.current.conversationKey
    if (key) _actions2.default.listScheduledMessages(key).catch(() => null)
  }, [])
  _useBus2.default.call(void 0, RECONNECT_ACTIONS, reload)

  // Starts an operation, or returns null while another is in flight.
  const begin = _react.useCallback.call(void 0, () => {
    if (inFlight.current !== null) return null
    nextOperation.current += 1
    const operation = nextOperation.current
    inFlight.current = operation
    setBusy(true)
    return { operation, chat: chatGeneration.current, edit: editGeneration.current }
  }, [])

  const end = _react.useCallback.call(void 0, (operation) => {
    if (inFlight.current !== operation) return
    inFlight.current = null
    setBusy(false)
  }, [])

  const openSendLater = _react.useCallback.call(void 0, () => {
    setSendLaterError(null)
    setSendLater({ kind: 'new' })
  }, [])

  const closeSendLater = _react.useCallback.call(void 0, () => {
    setSendLaterError(null)
    setSendLater(null)
  }, [])

  const leaveEditing = _react.useCallback.call(void 0, () => {
    editGeneration.current += 1
    setEditing(null)
    // A time being picked for the session goes with it.
    setSendLater(target => _optionalChain([target, 'optionalAccess', _ => _.kind]) === 'reschedule-failed' ? null : target)
    const stashed = { draft: stashedDraft.current, reply: stashedReply.current }
    stashedDraft.current = EMPTY_DRAFT
    stashedReply.current = null
    return stashed
  }, [])

  const stopEditing = _react.useCallback.call(void 0, () => {
    if (!latest.current.editing) return
    const { draft, reply } = leaveEditing()
    latest.current.composer.replaceDraft(draft.text, draft.mentions)
    latest.current.composer.replaceReply(reply)
  }, [leaveEditing])

  // Resolves true once the time is saved.
  const scheduleAt = _react.useCallback.call(void 0, async (sendAt) => {
    const { conversationKey: key, composer: draft, sendLater: target, now: clock } = latest.current
    if (!key || !target) return false
    const problem = _scheduledMessages.sendAtProblem.call(void 0, sendAt, clock())
    if (problem) {
      setSendLaterError(problem)
      return false
    }
    // A new message, or a failed one sent again, schedules the composer's
    // text with its mentions, replying to what the reply bar shows.
    const fromComposer = target.kind !== 'reschedule'
    const { text, mentions } = fromComposer ? draft.getDraft() : EMPTY_DRAFT
    const reply = fromComposer ? draft.getReply() : null
    if (fromComposer && _string.isBlank.call(void 0, text)) {
      setSendLaterError('Type a message first.')
      return false
    }
    const message = normalized(text, mentions)
    const tooLong = fromComposer ? tooLongFor(latest.current.channel, message.text) : null
    if (tooLong) {
      setSendLaterError(tooLong)
      return false
    }
    const started = begin()
    if (!started) return false
    const SendAt = sendAt.toISOString()
    const request = { ConversationKey: key, Text: message.text, SendAt, ...extrasFor(message.mentions, reply) }
    const sameChat = () => chatGeneration.current === started.chat
    // The panel still shows this choice.
    const samePanel = () => sameChat() && latest.current.sendLater === target
    try {
      if (target.kind === 'new') {
        await _actions2.default.scheduleMessage(request)
        // Clear only the draft that was sent, from the plain composer it was
        // sent from: newer typing, or an edit started since (even of a
        // message with the same text), stays. The reply bar clears the same
        // way, while it still shows the reply that was sent.
        if (sameChat() && editGeneration.current === started.edit) {
          const composer = latest.current.composer
          if (composer.getDraft().text === text) composer.replaceDraft('')
          if (reply && _optionalChain([composer, 'access', _2 => _2.getReply, 'call', _3 => _3(), 'optionalAccess', _4 => _4.messageKey]) === reply.messageKey) composer.replaceReply(null)
        }
      } else if (target.kind === 'reschedule-failed') {
        await _actions2.default.scheduleMessage(request)
        // The new one replaces the failed one, which leaves the thread (the
        // server has no way to reschedule a failed row in place).
        _actions2.default.dismissScheduledMessage({ ConversationKey: key, ScheduledMessageKey: target.message.ScheduledMessageKey })
          .catch(() => { if (sameChat()) latest.current.notify("Couldn't dismiss the message.") })
        // The session it was picked from ends, and the draft from before it
        // comes back; a session started since is left alone.
        if (sameChat() && editGeneration.current === started.edit) stopEditing()
      } else {
        const { message: row } = target
        await _actions2.default.editScheduledMessage({
          ConversationKey: key, ScheduledMessageKey: row.ScheduledMessageKey, ExpectedVersion: row.Version, SendAt,
        })
      }
      if (samePanel()) {
        setSendLaterError(null)
        setSendLater(null)
      }
      return true
    } catch (error) {
      if (!samePanel()) return false
      const { code, current } = _scheduledMessages.scheduledMessageErrorFrom.call(void 0, error)
      const errorText = _scheduledMessages.scheduledErrorText.call(void 0, error, fromComposer ? "Couldn't schedule the message." : "Couldn't change the time.")
      if (code === 'scheduled_message_not_scheduled') {
        setSendLater(null)
        latest.current.notify(errorText)
        return false
      }
      // A retry goes against the row as it is now.
      if (target.kind === 'reschedule' && code === 'scheduled_message_changed' && current) {
        setSendLater({ kind: 'reschedule', message: current })
      }
      setSendLaterError(errorText)
      return false
    } finally {
      end(started.operation)
    }
  }, [begin, end, stopEditing])

  const startEditing = _react.useCallback.call(void 0, (message, mode) => {
    const { composer, editing: current } = latest.current
    if (!current) {
      stashedDraft.current = composer.getDraft()
      stashedReply.current = composer.getReply()
    }
    editGeneration.current += 1
    setSendLater(null)
    setEditing({ message, mode, error: null, latest: null })
    // Its text with its mentions, and its reply in the reply bar, where its
    // ✕ removes it as for any draft.
    composer.replaceDraft(message.Text, _nullishCoalesce(message.Mentions, () => ( [])))
    composer.replaceReply(replyOf(message))
  }, [])

  const reloadEdit = _react.useCallback.call(void 0, () => {
    const editing = latest.current.editing
    const current = _optionalChain([editing, 'optionalAccess', _5 => _5.latest])
    if (!current) return
    setEditing({ message: current, mode: editing.mode, error: null, latest: null })
    latest.current.composer.replaceDraft(current.Text, _nullishCoalesce(current.Mentions, () => ( [])))
    latest.current.composer.replaceReply(replyOf(current))
  }, [])

  // Saves the text with the composer's mentions and the reply bar's reply.
  const saveEdit = _react.useCallback.call(void 0, async (text) => {
    const { conversationKey: key, editing: current, composer } = latest.current
    if (!key || !current) return
    if (_string.isBlank.call(void 0, text)) {
      setEditing({ ...current, error: "A scheduled message can't be empty." })
      return
    }
    const tooLong = tooLongFor(latest.current.channel, normalized(text, []).text)
    if (tooLong) {
      setEditing({ ...current, error: tooLong })
      return
    }
    if (current.mode === 'reschedule') {
      // Its new time is picked next; the composer's text goes then.
      if (current.error) setEditing({ ...current, error: null })
      setSendLaterError(null)
      setSendLater({ kind: 'reschedule-failed', message: current.message })
      return
    }
    const row = current.message
    const message = normalized(text, composer.getDraft().mentions)
    const replyKey = _nullishCoalesce(_optionalChain([composer, 'access', _6 => _6.getReply, 'call', _7 => _7(), 'optionalAccess', _8 => _8.messageKey]), () => ( ''))
    const replyChanged = replyKey !== (_nullishCoalesce(row.ReplyToMessageKey, () => ( '')))
    if (message.text === row.Text && sameMentions(message.mentions, _nullishCoalesce(row.Mentions, () => ( []))) && !replyChanged) {
      stopEditing()
      return
    }
    const started = begin()
    if (!started) return
    // The same chat and the same editing session the save began in.
    const sameSession = () => chatGeneration.current === started.chat && editGeneration.current === started.edit
    try {
      const saved = await _actions2.default.editScheduledMessage({
        ConversationKey: key,
        ScheduledMessageKey: row.ScheduledMessageKey,
        ExpectedVersion: row.Version,
        Text: message.text,
        // Mentions go with every text edit ([] for none), replacing the
        // stored ones; the reply only when it changed, '' removing it.
        Mentions: message.mentions,
        ...(replyChanged ? { ReplyToMessageKey: replyKey } : {}),
      })
      if (!sameSession()) return
      if (latest.current.composer.getDraft().text === text) {
        stopEditing()
        return
      }
      // Typed on after Save: keep editing, against the version just saved.
      setEditing({ message: saved, mode: 'edit', error: null, latest: null })
    } catch (error) {
      if (!sameSession()) return
      const { code, current: now } = _scheduledMessages.scheduledMessageErrorFrom.call(void 0, error)
      const message = _scheduledMessages.scheduledErrorText.call(void 0, error, "Couldn't save the message.")
      if (code === 'scheduled_message_not_scheduled') {
        // Too late to edit: the edited text and its reply stay in the composer.
        leaveEditing()
        latest.current.notify(message)
        return
      }
      setEditing({ ...current, error: message, latest: code === 'scheduled_message_changed' ? now : null })
    } finally {
      end(started.operation)
    }
  }, [begin, end, stopEditing, leaveEditing])

  // While an edit has the composer, it holds the scheduled text, not the
  // chat's draft: a screen saving the draft as it leaves the chat saves this
  // one, from before the edit, instead. Null when not editing.
  const draftWhileEditing = _react.useCallback.call(void 0, 
    () => latest.current.editing ? stashedDraft.current : null,
    [],
  )

  const keepScheduled = _react.useCallback.call(void 0, () => setConfirmingCancel(null), [])

  const confirmCancel = _react.useCallback.call(void 0, () => {
    const { conversationKey: key, confirmingCancel: message, editing: current, sendLater: target } = latest.current
    setConfirmingCancel(null)
    if (!key || !message) return
    const cancelled = message.ScheduledMessageKey
    // Editing it ends, as Stop editing would; any other draft stays as it is.
    if (_optionalChain([current, 'optionalAccess', _9 => _9.message, 'access', _10 => _10.ScheduledMessageKey]) === cancelled) stopEditing()
    if (_optionalChain([target, 'optionalAccess', _11 => _11.kind]) === 'reschedule' && target.message.ScheduledMessageKey === cancelled) closeSendLater()
    _scheduledCancels2.default.cancel({
      conversationKey: key,
      message,
      now: latest.current.now().getTime(),
      // Sent late, perhaps after the chat closed: staff still hear it failed.
      onError: error => latest.current.notify(_scheduledMessages.scheduledErrorText.call(void 0, error, "Couldn't cancel the message.")),
    })
  }, [stopEditing, closeSendLater])

  const undoCancel = _react.useCallback.call(void 0, (key) => _scheduledCancels2.default.undo(key), [])

  const runAction = _react.useCallback.call(void 0, (action, message) => {
    const key = latest.current.conversationKey
    if (!key) return
    const chat = chatGeneration.current
    const report = (fallback) => (error) => {
      if (chatGeneration.current === chat) latest.current.notify(_scheduledMessages.scheduledErrorText.call(void 0, error, fallback))
    }
    const target = { ConversationKey: key, ScheduledMessageKey: message.ScheduledMessageKey }
    switch (action) {
      case 'edit':
        startEditing(message, 'edit')
        return
      case 'reschedule':
        startEditing(message, 'reschedule')
        return
      case 'changeTime':
        setSendLaterError(null)
        setSendLater({ kind: 'reschedule', message })
        return
      case 'sendNow':
        _actions2.default.sendScheduledMessageNow({ ...target, ExpectedVersion: message.Version })
          .catch(report("Couldn't send the message."))
        return
      case 'retry':
        // A reason that still stops it is refused, with the row unchanged.
        _actions2.default.retryScheduledMessage({ ...target, ExpectedVersion: message.Version })
          .catch(report("Couldn't send the message."))
        return
      case 'cancel':
        setConfirmingCancel(message)
        return
      case 'dismiss':
        _actions2.default.dismissScheduledMessage(target).catch(report("Couldn't dismiss the message."))
    }
  }, [startEditing])

  return {
    sendLater,
    sendLaterError,
    openSendLater,
    closeSendLater,
    scheduleAt,
    editing,
    saveEdit,
    stopEditing,
    reloadEdit,
    draftWhileEditing,
    confirmingCancel,
    confirmCancel,
    keepScheduled,
    cancelToast,
    undoCancel,
    runAction,
    busy,
  }
}; exports.useScheduledMessageFlow = useScheduledMessageFlow


